// src/pages/public/CreditApplicationConfirmation.tsx
import React from 'react';
import { useLocation, useParams, Link } from 'react-router-dom';
import { CheckCircle2, ShieldCheck, FileCheck, Mail, ArrowRight } from 'lucide-react';

export const CreditApplicationConfirmation: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const location = useLocation();
  const state = (location.state as any) || {};

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-lg w-full bg-white border border-slate-200 rounded-2xl shadow-sm p-6 sm:p-8 space-y-6 text-center">
        <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto text-[#0f5a2e]">
          <CheckCircle2 className="w-10 h-10" />
        </div>

        <div className="space-y-2">
          <span className="text-[11px] font-bold uppercase tracking-wider text-[#0f5a2e] bg-emerald-50 px-2.5 py-1 rounded-full border border-emerald-200">
            Submission Confirmed
          </span>
          <h1 className="text-xl font-bold text-slate-900">Credit Application Received</h1>
          <p className="text-xs text-slate-600 max-w-sm mx-auto">
            Your business credit intake form has been securely received, sealed with cryptographic audit evidence, and logged for commercial review.
          </p>
        </div>

        <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 text-left space-y-2.5 text-xs">
          <div className="flex justify-between items-center py-1 border-b border-slate-200">
            <span className="text-slate-500 font-medium">Application Reference:</span>
            <span className="font-mono font-bold text-slate-900">{state.reference_no || 'Recorded'}</span>
          </div>
          <div className="flex justify-between items-center py-1 border-b border-slate-200">
            <span className="text-slate-500 font-medium">Audit Event Ref:</span>
            <span className="font-mono text-slate-700">{state.auditRef || 'Verified'}</span>
          </div>
          <div className="flex justify-between items-center py-1">
            <span className="text-slate-500 font-medium">Status:</span>
            <span className="font-semibold text-emerald-700">Submitted & Pending Assessment</span>
          </div>
        </div>

        <div className="space-y-2 text-xs text-slate-500 text-left bg-emerald-50/60 border border-emerald-100 p-3 rounded-lg">
          <div className="flex items-start gap-2">
            <FileCheck className="w-4 h-4 text-[#0f5a2e] flex-shrink-0 mt-0.5" />
            <span>Digital PDF intake form and verification evidence reports have been generated and archived.</span>
          </div>
          <div className="flex items-start gap-2">
            <Mail className="w-4 h-4 text-[#0f5a2e] flex-shrink-0 mt-0.5" />
            <span>Notification has been forwarded to Geobit Group Credit Review Committee.</span>
          </div>
        </div>

        <div className="pt-2 text-xs text-slate-400">
          Note: Submission of this form initiates credit assessment and does not constitute guarantee of requested credit facility approval.
        </div>
      </div>
    </div>
  );
};
